import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getDocs, getDocsReq } from "../actions/getDocs";
import { loadRoutes } from "../actions/loadRoutes";
import { resetDocForm } from "../actions/resetDocFom";
import { IP } from "../config/IP";
import store from "../store/createStore";
import TABLE from "./containers/Table";
import Home from "./HomeEditingDoc";

function TabPanel(props) {
	const { children, value, index, ...other } = props;
	useEffect(() => {
		//console.log("TabPanel mounted");
		return () => {
			//console.log("TabPanel unmounted");
		};
	}, [props]);

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`wrapped-tabpanel-${index}`}
			aria-labelledby={`wrapped-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `wrapped-tab-${index}`,
		"aria-controls": `wrapped-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
}));

const DocProcessingScreen = () => {
	const classes = useStyles();
	const [value, setValue] = React.useState("one");
	const [DocId, setDocId] = React.useState("");
	const dispatch = useDispatch();
	let state = useSelector((state) => state);

	let inputs = {
		url: IP.nodeServer + "api/routesRules",
		method: "POST",
		data: [{ name: "Doc_type_id", value: parseInt(1) }],
	};

	const [office_id, setOffice_id] = React.useState(
		state.auth.user.office[0].office_id
	);
	const [firstLoad, setFirstLoad] = React.useState(true);
	const [pageNumber, setPageNumber] = React.useState(1);
	const [numberRowPerPage, setNumberRowPerPage] = React.useState(5);
	const [totalRow, setTotalRow] = React.useState(20);

	const [dataloading, setDataloading] = React.useState({
		data: null,
		file: null,
		loading: true,
	});
	//console.log("dataloading=", dataloading);

	const [loadingCond, setLoadingCond] = React.useState(false);
	inputs = {
		url: IP.nodeServer + "api/getDocs",
		method: "POST",
		office_id: office_id,
		companyId: state.companyData.selectedCompanyId,
		action: 1,
		page: pageNumber,
		limit: numberRowPerPage,
	};

	/*
			docsreq.docs.data.docs
			docsreq.docs.data.file
			docsreq.docs.data.docs
			docsreq.docs.data.limit
			docsreq.docs.data.page
			docsreq.docs.data.total
			docsreq.isDone
			*/

	const handleChange = (event, newValue, newDocId) => {
		//console.log("handleChange=", newValue);
		inputs = {
			url: IP.nodeServer + "api/getDocs",
			method: "POST",
			office_id: office_id,
			companyId: state.companyData.selectedCompanyId,
			page: pageNumber,
			limit: numberRowPerPage,
			action: 1,
		};

		setValue(newValue);
		if (newDocId) {
			//if (newValue === "two") {
			let inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				id: newDocId,
				companyId: state.companyData.selectedCompanyId,
				page: pageNumber,
				limit: numberRowPerPage,
			};

			//getDocsById(inputs);

			setDocId(newDocId);
			//}
		}
		if (newValue === "one") {
			dispatch(resetDocForm());
			setOffice_id("");
			//console.log("handleChange 2=", newValue);
			setOffice_id(state.auth.user.office[0].office_id);

			setLoadingCond(false);
		} else {
			setOffice_id(state.auth.user.office[0].office_id);

			setLoadingCond(true);
		}
	};
	const handleChangeTablePage = (value) => {
		setDataloading({
			data: null,
			file: null,
			loading: true,
		});

		setFirstLoad(false);
		console.log("handleChangeTablePage Clicked");
		setPageNumber(value + 1);
		console.log("pageNumber after handleChangeTablePage=", pageNumber);
	};
	const onChangeTableRowsPerPage = (value) => {
		console.log("onChangeTableRowsPerPage Clicked!");
	};

	/*
	
	*/
	//console.log("state.auth.user.office=", state.auth.user.office);

	//console.log("data in DocProcessingScreen=", dataloading.data);
	/*
	

	
	
	*/
	// before creating Docs Details
	//console.log("DocId before return=", DocId);
	//let details = DocId !== null && <DocDetails DocId={DocId} />;
	let details;

	//console.log("value DocId.DocId=" + DocId.length);
	if (value === "two" && DocId.length > 0) {
		console.log(
			"HomeEditingDoc tab value===two dataloading.data.data=",
			dataloading.data
		);
		details = DocId !== null && (
			<Home
				docType={dataloading.data.data.find((x) => x.id === DocId).DocType}
				DocId={DocId}
				office_id={dataloading.data.data.find((x) => x.id === DocId).office_id}
				office_name={
					dataloading.data.data.find((x) => x.id === DocId)
						.OwnerOfficeLocationName
				}
				isActing={
					dataloading.data.data.find((x) => x.id === DocId).office_id ===
					state.auth.user.office[0].office_id
						? false
						: true
				}
			/>
		);
	}
	const loadnew = () => {
		setDataloading({
			data: null,
			file: null,
			loading: true,
		});
		try {
			if (store.getState().docsreq.isDone) {
				let currentstate = store.getState();

				let response = currentstate.docsreq.docs;

				if (response.data) {
					console.log("axios response=", response);
					let doclist = response.data;
					let docsin = [];
					let respCondition = false;

					let data = [];
					let files = [response.data.file];
					let direction;
					console.log("doclist=", doclist);
					doclist.docs.map((doclist) => {
						if (!doclist.currentSituation.action) {
							respCondition = true;
						}
						if (doclist.currentSituation.direction == 1) {
							direction = <ArrowUpwardIcon />;
						} else if (doclist.currentSituation.direction == -1) {
							direction = <ArrowDownwardIcon />;
						} else {
							direction = "";
						}

						data.push({
							DocName: doclist.DocName,
							DocType: doclist.DocType,
							DocTypeDescription: currentstate.loadRoutes.docType.filter(
								(x) => x.Doc_type_id === parseInt(doclist.DocType)
							)[0].name,

							currentOfficeLocation:
								doclist.currentSituation.currentOfficeLocation,

							currentOfficeLocationName: currentstate.auth.user.allOffices.filter(
								(x) =>
									x.office_id === doclist.currentSituation.currentOfficeLocation
							)[0].office_name,
							office_id: doclist.office_id,
							OwnerOfficeLocationName: currentstate.auth.user.allOffices.filter(
								(x) => x.office_id === doclist.office_id
							)[0].office_name,
							CreatorUserId: doclist.CreatorUserId,
							CreatorUserName: currentstate.auth.user.allUser.find(
								(y) => y._id === doclist.CreatorUserId
							).username,

							direction: direction,
							status: doclist.currentSituation.status,
							statusDescription: doclist.currentSituation.statusDescription,
							statusDate: doclist.currentSituation.statusDate,
							action: currentstate.auth.user.settings[0].action.filter(
								(x) => x.id == parseInt(doclist.currentSituation.action)
							)[0].actionDescription,
							actionDate: doclist.currentSituation.actionDate,
							id: doclist._id,
							comments: doclist.comments,
							StepProgress: doclist.StepProgress,
							historySituation: doclist.historySituation,
							deleteDisabled: true,
						});
					});
					docsin = {
						title: "Available Documents",
						columns: [
							{ title: "DocName", field: "DocName" },
							{ title: "DocTypeDescription", field: "DocTypeDescription" },
							{
								title: "OwnerOfficeLocationName",
								field: "OwnerOfficeLocationName",
							},
							{
								title: "CreatorUserName",
								field: "CreatorUserName",
							},
							{
								title: "currentOfficeLocationName",
								field: "currentOfficeLocationName",
							},
							{ title: "direction", field: "direction" },
							{ title: "statusDescription", field: "statusDescription" },
							{ title: "statusDate", field: "statusDate" },
							{ title: "action", field: "action" },
							{ title: "actionDate", field: "actionDate" },
							{ title: "id", field: "id" },
						],
						data: data,
					};
					console.log("docsin=", docsin);

					setDataloading({
						data: docsin,
						files: files,
						loading: respCondition,
						total: response.data.total,
						limit: response.data.limit,
						page: response.data.page,
						pages: response.data.pages,
					});
					setTotalRow(response.data.total);
				}
			}
		} catch (e) {
			console.log("error issue=", e);
		}
	};

	useEffect(() => {
		//console.log("dataloading in data=", data);
		//dispatch(getDocsReq(inputs));
		if (dataloading.loading) {
			console.log("firstLoad after handleChangeTablePage=", firstLoad);
			loadnew();
		}
	}, [value, setValue, dataloading.loading, store.getState().docsreq.isDone]);
	console.log("dataloading=", dataloading);

	console.log("dataloading=", dataloading);

	return (
		<div className={classes.root}>
			<AppBar position="static">
				<Tabs
					value={value}
					onChange={handleChange}
					//onClick={handleClick}
					aria-label="wrapped label tabs example"
				>
					<Tab
						value="one"
						label="Document List"
						wrapped
						{...a11yProps("one")}
					/>
					<Tab value="two" label="Document Details" {...a11yProps("two")} />
				</Tabs>
			</AppBar>
			<TabPanel value={value} index="one">
				{dataloading.loading ? (
					"Loading"
				) : (
					<TABLE
						Inputs={dataloading.data}
						handleChange={handleChange}
						issuer="DocProcessingScreen"
						showActions={true}
						handleChangeTablePage={handleChangeTablePage}
						onChangeTableRowsPerPage={onChangeTableRowsPerPage}
						pageNumber={pageNumber}
						firstLoad={firstLoad}
						numberRowPerPage={numberRowPerPage}
						totalRow={totalRow}
					/>
				)}
			</TabPanel>
			<TabPanel value={value} index="two">
				{dataloading.loading ? "loading out" : details}
			</TabPanel>
		</div>
	);
};
const mapDispatchToProps = (dispatch) => ({
	getDocs: (data) => dispatch(getDocs(data)),
	loadRoutes: (data) => dispatch(loadRoutes(data)),
	getDocsReq: (data) => dispatch(getDocsReq(data)),
	resetDocForm: () => dispatch(resetDocForm),
});
const mapStateToProps = (state) => ({
	state,
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DocProcessingScreen);
